export function canonicalDivision(value) {
  const normalized = String(value || "")
    .trim()
    .toUpperCase()
    .replace(/\s+/g, " ");

  if (!normalized) return "";
  if (normalized === "ALL" || normalized === "SEMUA") return "ALL";
  if (/WELLNESS|TCM|TRAD/.test(normalized)) return "WELLNESS";
  if (/ESTETIK|AESTHETIC|KECANTIKAN/.test(normalized)) return "ESTETIK";
  if (/DENTAL|GIGI/.test(normalized)) return "DENTAL";
  if (/DOKTER[ _-]*UMUM|POLI UMUM|\bUMUM\b/.test(normalized)) return "DOKTER_UMUM";
  if (/FISIOTERAPI|PHYSIO/.test(normalized)) return "FISIOTERAPI";
  if (/APOTIK|FARMASI/.test(normalized)) return "APOTIK";
  if (/SALON/.test(normalized)) return "SALON";

  return normalized.replace(/[ /-]+/g, "_");
}

export function divisionLabel(value) {
  switch (canonicalDivision(value)) {
    case "WELLNESS": return "Wellness / TCM";
    case "ESTETIK": return "Poli Estetik";
    case "DENTAL": return "Poli Gigi";
    case "DOKTER_UMUM": return "Poli Umum";
    case "FISIOTERAPI": return "Fisioterapi";
    case "APOTIK": return "Apotik";
    case "SALON": return "Salon";
    default: return "Umum";
  }
}
